const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Authorization Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('AuthorizationResource', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/v3/authtoken/:subresource', null, {
    signin: {params: {}, method: 'POST', isArray: false},
    oauth: {params: {subresource: 'oauth'}, method: 'POST', isArray: false},
    newToken: {params: {}, method: 'GET', isArray: false},
    refresh: {params: {subresource: 'refresh'}, method: 'POST', isArray: false}
  });
}]);